import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChildren } from '@angular/core';
import { EmailGet } from '../email.service';
import { EmailFolderTreeDataSourceDirective, GraphMailFolderNode } from '../email-folder-tree-data-source.directive';

@Component({
    selector: 'tt-email-mail-folders',
    templateUrl: './email-mail-folders.component.html',
    styleUrls: ['./email-mail-folders.component.css'],
})
export class EmailMailFoldersComponent implements AfterViewInit {
    @Input()
    public get!: EmailGet;

    @Output()
    public selectedFolderChange = new EventEmitter<GraphMailFolderNode[]>();

    @Output()
    public onTreeReady = new EventEmitter<EmailFolderTreeDataSourceDirective>();

    @ViewChildren(EmailFolderTreeDataSourceDirective)
    public emailFoldersDataSource?: EmailFolderTreeDataSourceDirective;

    public ngAfterViewInit(): void {
        this.onTreeReady.emit(this.emailFoldersDataSource);
    }
}
